module.exports = __webpack_public_path__ + "static/media/hubspot.12605c80.svg";